// Centralized backend URI resolution.
// Build-time env should win for both the main app and the widget.
// Priority: VITE_API_BASE_URL > window BACKEND_URI > relative paths
const normalizeBackendUri = (value: string | undefined | null): string => {
    const trimmed = (value || "").trim();
    if (!trimmed) return "";
    return trimmed.replace(/\/+$/, "");
};

export const getBackendUri = (): string => {
    const envBackend = normalizeBackendUri(import.meta.env.VITE_API_BASE_URL);
    const windowBackend = normalizeBackendUri((window as any).BACKEND_URI);

    // VITE_API_BASE_URL: set when frontend is hosted separately (e.g. Azure SWA)
    // pointing to the OpenShift gateway. Empty/unset = relative paths (nginx proxy).
    if (envBackend) {
        console.debug("[backendUri] using VITE_API_BASE_URL", {
            source: "vite_env",
            value: envBackend
        });
        return envBackend;
    }

    if (windowBackend) {
        console.debug("[backendUri] using window.BACKEND_URI", {
            source: "window",
            value: windowBackend
        });
        return windowBackend;
    }

    // Local nginx and the Vite development servers proxy relative API requests
    // to the n8n API gateway. The retired app/backend service is never used.
    console.debug("[backendUri] using relative paths", {
        source: "relative_paths",
        value: "(empty => relative URLs)"
    });
    return "";
};
